import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useFieldAttributes } from '../../../services/field-attributes';
import { useFieldInitialData } from '../../../contexts/field-initial-data-context';
import { AppointmentFieldWUT } from '../../../ui/appointment-field/appointment';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { FieldLabelWUT } from '../../../ui/field-label/field-label-wut';
import { FIELD_TYPES } from '../../../constants';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
export const AppointmentWUT = props => {
  const {
    id,
    description,
    error,
    hasError = false,
    errorMessage,
    required,
    label,
    hideLabel,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    target
  } = props;
  const {
    labelId,
    inputId,
    descriptionId,
    ariaDescribedBy,
    errorId
  } = useFieldAttributes(id, error, description);
  const initialData = useFieldInitialData(FIELD_TYPES.APPOINTMENT);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(AppointmentFieldWUT, _extends({}, props, {
      initialData: initialData,
      inputId: inputId,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy,
      fieldId: id
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=appointment-wut.js.map